import { DecimalPipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnChanges } from '@angular/core';
import { WriteReviewBtnComponent } from '@uc/web/shared/buttons';
import {
	ReversedStars,
	UniversityRatingStats,
	UniversityStars,
} from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-university-reviews-stats',
	templateUrl: './university-reviews-stats.component.html',
	imports: [NgStyle, DecimalPipe, WriteReviewBtnComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversityReviewsStatsComponent implements OnChanges {
	universityRatingStats = input<UniversityRatingStats | undefined | null>();
	universityUrl = input<string>('');
	universityRating = input<number>();
	totalReviews = input<number | undefined>();
	uniId = input<number>();
	uniName = input<string>('');
	reversedStars: ReversedStars[] = [];

	convertObjectToArray(obj?: Record<keyof UniversityStars, number>): ReversedStars[] {
		if (!obj) return [];
		return Object.keys(obj)
			.map((key) => {
				return { key: key, value: obj[key] };
			})
			.reverse();
	}

	ngOnChanges(): void {
		this.reversedStars = this.convertObjectToArray(
			this.universityRatingStats()?.stars,
		);
	}
}
